import React from 'react';
import Div from "@jumbo/shared/Div";
import PropTypes from 'prop-types';

const JumboContentLayoutFooter = ({children}) => {
    return (
        <Div
            sx={{
                padding: theme => theme.spacing(2, 3),
                backgroundColor: theme => theme.palette.error.main,
            }}
            className="CmtLayout-footer"
        >
            {children}
        </Div>
    );
};

JumboContentLayoutFooter.propTypes = {
    children: PropTypes.node
}

export default JumboContentLayoutFooter;
